import type { Components, Theme } from "@mui/material";

export const MuiMenu: Components<Theme>["MuiMenu"] = {
	defaultProps: {
		anchorOrigin: {
			vertical: "top",
			horizontal: "right",
		},
		transformOrigin: {
			vertical: "bottom",
			horizontal: "right",
		},
	},
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				".MuiPaper-elevation": {
					background: theme.palette.background.default,
					borderRadius: theme.spacing(2),
					borderColor: theme.palette.muted.dark,
					borderStyle: "solid",
					borderWidth: 1,
					boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
				},
				".MuiMenu-list": {
					padding: theme.spacing(1),
				},
			}),
		},
	],
};

export const MuiMenuItem: Components<Theme>["MuiMenuItem"] = {
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				borderRadius: theme.spacing(1),
				fontSize: theme.typography.pxToRem(14),
				fontWeight: 600,
				gap: theme.spacing(1),
				lineHeight: 1,
				minWidth: theme.spacing(18),
				padding: theme.spacing(1.5),
				svg: {
					height: theme.spacing(2.25),
					width: theme.spacing(2.25),
				},
			}),
		},
		{
			props: { color: "destructive" },
			style: ({ theme }) => ({
				svg: {
					color: theme.palette.error.main,
				},
				"&:hover": {
					backgroundColor: theme.palette.error.background,
				},
			}),
		},
	],
};
